export function emitter() {
    const listeners = new Set();
    emit.subscribe = subscribe;
    return emit;
    function emit(data) {
        // Copied to prevent modifications while it runs
        const copy = Array.from(listeners);
        copy.forEach(listener => listener(data));
        return Boolean(listeners.size);
    }
    function subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    }
}
//# sourceMappingURL=emitter.js.map